export interface BasicUser {
  fullName?: string;
  firstName?: string;
  lastName?: string;
  avatarUrl?: string;
  id?: string;
}

const BASE_SATURATION = 100;
const BASE_LIGHTNESS = 25;
const HUE_COUNT = 100;
const HUE_STEP = 360 / HUE_COUNT;

const generateAvatarColors = (): string[] => {
  const colors: string[] = [];

  for (let i = 0; i < HUE_COUNT; i++) {
    const hue = i * HUE_STEP;
    colors.push(`hsl(${hue}, ${BASE_SATURATION}%, ${BASE_LIGHTNESS}%)`);
  }

  return colors;
};

const AVATAR_COLORS = generateAvatarColors();

const hashString = (str: string): number => {
  let hash = 0;

  for (let i = 0; i < str.length; i++) {
    hash = ((hash << 5) - hash + str.charCodeAt(i)) | 0;
  }

  return Math.abs(hash);
};

export const getUserAvatarColor = (user: BasicUser | null | undefined): string => {
  const fullName = getUserFullName(user);

  if (!fullName) {
    return AVATAR_COLORS[0];
  }

  const hash = hashString(fullName);
  const colorIndex = hash % AVATAR_COLORS.length;

  return AVATAR_COLORS[colorIndex];
};

export const getUserInitials = (user: BasicUser | null | undefined) => {
  if (user?.fullName) {
    return user.fullName
      .split(' ')
      .slice(0, 2)
      .map(name => name[0])
      .join('')
      .toUpperCase();
  }

  return [user?.firstName?.[0], user?.lastName?.[0]].filter(Boolean).join('').toUpperCase();
};

export const getUserFullName = (user: BasicUser | null | undefined) => {
  if (user?.fullName) {
    return user.fullName;
  }

  return [user?.firstName, user?.lastName].filter(Boolean).join(' ');
};
